export default __webpack_public_path__ + "static/Principle-harmony-dark-ff45813463ab73f1c8bae5e17dd1ee12.png";